import React, {useEffect, useState} from "react";
import Logo from "../../assets/image/splash-logo.svg";
import {useAuth} from "@common/contexts/auth/AuthProvider";
import {isMobileAndroidApp, isMobileIosApp, isMobileApp} from "@common/utils/app/appUtils";
import SocialLogin from "@common/enums/SocialLogin.enums";
import LoadingView from "@common/components/loading/LoadingView"
import AppConnectView from "../../views/AppConnectView"
import {convertPath, convertHttpUrl} from "@common/utils/path/linkPath";

function Login () {
  const auth = useAuth();

  return (
    <div className="login">
      {
        (isMobileApp() || process.env.PROFILE !== 'production') ?
          !auth.adicUser ?
            <>
              <img src={Logo} alt="" className="logo"/>
              {
                auth && auth.socialProvider.map((provider, index) => {
                  // if (isMobileAndroidApp() && provider.enumKey === SocialLogin.apple.enumKey) {
                  //   return null;
                  // }
                  // else if (isMobileIosApp() && provider.enumKey === SocialLogin.google.enumKey) {
                  //   return null;
                  // }
                  const onSubmit = () => {
                    auth.signIn(provider.enumKey).catch((error) => {
                      alert('로그인을 실패하였습니다 ' +error);
                    });
                  };
                  return(
                    <button key={`provider-btn-${index}`} className={provider.enumKey} onClick={onSubmit}><img src={provider.buttonImage} className={provider.imgClassName} alt=""/>{provider.name}</button>
                  )
                })
              }
            </>
            :
            <LoadingView/>
          :
          <AppConnectView isFullView={true} />
      }
    </div>
  )
}

export default Login;
